"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var uriTemplates = require("uri-templates");
var URI = /** @class */ (function () {
    function URI(uri, templated, fetchedURI) {
        if (templated === void 0) { templated = false; }
        if (fetchedURI === void 0) { fetchedURI = ""; }
        this.uri = uri;
        this.templated = templated;
        this.fetchedURI = fetchedURI;
        if (templated) {
            this.uriTemplates = uriTemplates(uri);
        }
    }
    Object.defineProperty(URI.prototype, "resourceURI", {
        get: function () {
            if (this.templated) {
                if (this.fetchedURI != "") {
                    return this.fetchedURI;
                }
                throw new Error("can not call delete on resource with templated link");
            }
            else {
                return this.uri;
            }
        },
        enumerable: true,
        configurable: true
    });
    URI.prototype.fill = function (params) {
        if (params === void 0) { params = {}; }
        if (this.templated && this.uriTemplates) {
            return this.uriTemplates.fill(params);
        }
        else {
            return this.uri;
        }
    };
    return URI;
}());
exports.URI = URI;
//# sourceMappingURL=uri.js.map